import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { Module } from 'vuex'
import { State } from '@/store/store'
import { PaymentHistoryState } from './states'

const AdsAccount: Module<PaymentHistoryState, State> = {
  state: new PaymentHistoryState(),
  actions,
  mutations,
  getters,
  namespaced: true,
}

export default AdsAccount
